module.exports = __webpack_public_path__ + "img/Amazings.086bbaa5.svg";